import { mapMutations, mapState } from 'vuex';
import MusicDetails from '@/components/MusicListItem/MusicDetails.vue';
export default {
  name: 'FooterMusci',

  data() {
    return {
      interval: 0,
      myduration: null
    };
  },

  components: {
    MusicDetails
  },
  computed: { ...mapState(['playList', 'playListIndex', 'isbtnShow', 'isPopups', 'duration'])
  },

  updated() {
    this.$store.dispatch("getLyric", this.playList[this.playListIndex].id);
    this.addDuration();
  },

  mounted() {
    this.$store.dispatch("getLyric", this.playList[this.playListIndex].id);
    this.updateTime();
  },

  methods: {
    play() {
      this.updateTime(); //判断音乐是否播放

      if (this.$refs.audio.paused) {
        this.$refs.audio.play();
        this.updateIsbtnShow(false);
      } else {
        this.$refs.audio.pause();
        this.updateIsbtnShow(true);
        clearInterval(this.interval); //暂停清除定时器
      }
    },

    myFunction() {
      this.myduration = this.$refs.audio.duration; // console.log(this.myduration);
    },

    addDuration() {
      this.updateduration(this.myduration);
    },

    updateTime() {
      this.interval = setInterval(() => {
        this.updatecurrenTime(this.$refs.audio.currentTime);
      }, 2000);
    },

    ...mapMutations(['updateIsbtnShow', 'updateIsPopups', 'updatecurrenTime', 'updateduration'])
  },
  watch: {
    //监听,如果下标发生改变就自动播放音乐
    playListIndex() {
      this.$refs.audio.autoplay = true; //如果是暂停状态改变图标

      if (this.$refs.audio.paused) this.updateIsbtnShow(false);
    },

    playList() {
      if (this.isbtnShow) {
        this.$refs.audio.autoplay = true;
        this.updateIsbtnShow(false);
      }
    }

  }
};